import React, { Component } from "react"
import classnames from "classnames"
import HomeLogoIcon from "svg-inline-react"
import { Icon, ToolTip, A } from "@driftt/tide-core-legacy"
import ACCESS from "utils/Access"
import { DRIFT_APP_DOMAIN } from 'constants/ResourcesConstants'

import { getDriftCutover } from 'app/modules/access/api'
import { getConfig } from 'app/modules/navConfig/api'

import UpgradeStatus from "./UpgradeStatus"
import NewAgentStatus from "./NewAgentStatus"
import AppSwitcher from "./AppSwitcher"
import Settings from "./Settings"
import Help from "./Help"
import Onboarding from './Onboarding'

import LOGO from "!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/drift-icon-2020.svg"
import "./style.styl"

const MAX_UNGROUPED_NAV_ITEMS = 4

class MainNav extends Component {
  constructor(props) {
    super(props)

    const groupedNavItemsExpanded = window.localStorage
      ? window.localStorage.getItem('traffic-control_salesToolsExpanded') === 'true'
      : false

    this.state = {
      isPendingCutover: true,
      hasDriftHelpCutover: false,
      hasVideoIconCutover: false,
      scrollContainerHovered: false,
      groupedNavItemsExpanded,
    }
  }

  async componentWillMount() {
    const hasDriftHelpCutoverGate = async () => {
      return await getDriftCutover({ orgId: this.props.orgId, cutoverName: 'DRIFT_HELP' })
    }
    const hasDriftVideoCutoverGate = async () => {
      return await getDriftCutover({ orgId: this.props.orgId, cutoverName: 'DRIFT_VIDEO_IN_NAV' })
    }

    const fetchNavConfig = async () => {
      return await getConfig('/nav-config/index.json')
    }

    try {
      const { DRIFT_HELP: hasHelpCutoverGate } = await hasDriftHelpCutoverGate()
      const { DRIFT_VIDEO_IN_NAV: hasVideoIconCutoverGate } = await hasDriftVideoCutoverGate()
      const { data: NAV_CONFIG } = await fetchNavConfig()
      this.setState({ 
        hasDriftHelpCutover: hasHelpCutoverGate,  
        hasVideoIconCutover: hasVideoIconCutoverGate, 
        isPendingCutover: false,
        navConfig: NAV_CONFIG
      })
    }
    catch(err) {
      console.warn(err)
      this.setState({ isPendingCutover: false })
    }
  }

  hideNav() {
    return (
      this.props.location.pathname.includes("welcome/") ||
      this.props.location.pathname.includes("install/verify") ||
      this.props.location.pathname.includes("setup-slack") ||
      this.props.location.pathname == "/oauth" ||
      (this.props.location.pathname.includes("/install/") &&
        !this.props.location.pathname.includes("/settings/setup"))
    )
  }

  isHomePath() {
    return (
      this.props.location.pathname === "/" ||
      this.props.location.pathname.startsWith("/home") ||
      this.props.location.pathname.startsWith("/dashboard")
    )
  }

  resolveHomePath() {
    const { navConfig } = this.state
    const availableHomePaths = navConfig.HOME_PATH_RULES.filter(this.checkPathCriteria)

    return availableHomePaths[0] ? availableHomePaths[0].path : '/'
  }

  checkPathCriteria(item) {
    const userHasImpliedAccess =
      (ACCESS.hasAnyScope(item.requiredScopes) && !ACCESS.hasAnyScope(item.rejectIfHasScopes)) ||
      ACCESS.hasAnyRole(item.requiredRoles) ||
      ACCESS.hasAllGates(item.hasAllUserGates)
  
    const userHasRbacAccess =
      ACCESS.hasFeatures(item.requiredFeatures) ||
      ACCESS.hasAnyFeature(item.hasAnyFeature)

    const orgHasAccess = 
      (item.requiredGates ? ACCESS.hasGates(item.requiredGates) : true) &&
      (item.rejectIfHasGates ? !ACCESS.hasGates(item.rejectIfHasGates) : true) &&
      (item.hasAllGates ? ACCESS.hasAllGates(...item.hasAllGates) : true)

    return (userHasImpliedAccess || userHasRbacAccess) && orgHasAccess
  }
  
  resolveAvailableNavItems() {
    const { navConfig } = this.state

    let navCollection = navConfig.NAV_COLLECTIONS.DEFAULT
    if (ACCESS.hasGates('has_unified_nav') && navConfig.NAV_COLLECTIONS.UNIFIED) {
      navCollection = navConfig.NAV_COLLECTIONS.UNIFIED
    }
    if (ACCESS.isRbacUser() && navConfig.NAV_COLLECTIONS.RBAC) {
      navCollection = navConfig.NAV_COLLECTIONS.RBAC
    }

    if (ACCESS.hasAnyDefaultRole('Sales Rep') && navConfig.NAV_COLLECTIONS.RBAC_REP) {
      navCollection = navConfig.NAV_COLLECTIONS.RBAC_REP
    }

    const navItems = _.pick(navConfig.NAV_ITEMS, navCollection)

    return Object.values(navItems).filter(this.checkPathCriteria)
  }

  renderNavItems = () => {
    const availableNavItems = this.resolveAvailableNavItems()

    const ungroupedItems = ACCESS.isRbacUser() ? availableNavItems.slice(0, MAX_UNGROUPED_NAV_ITEMS) : availableNavItems
    const groupedItems = ACCESS.isRbacUser() ? availableNavItems.slice(MAX_UNGROUPED_NAV_ITEMS) : []

    const expanded = this.state.groupedNavItemsExpanded

    const setExpanded = setter => this.setState(prevState => {
      const nextValue = setter(prevState.groupedNavItemsExpanded)

      if (window.localStorage) {
        window.localStorage.setItem('traffic-control_salesToolsExpanded', nextValue)
      }

      return {
        groupedNavItemsExpanded: nextValue
      }
    })

    return (
      <nav className="main-navigation--nav-items">
        {ungroupedItems.map(item => this.renderNavItem(item))}
        {groupedItems.length > 0 && (
          <div className="navigation-sales-tools">
            {expanded && groupedItems.map(item => this.renderNavItem(item))}
            <ToolTip key={expanded} component={expanded ? 'Collapse navigation' : 'Expand navigation'} tethered>
              <button className="nav-item sales-tools-expand-button"
                onClick={() => setExpanded(expanded => !expanded)}>
                <div className="sales-tools-expand-button-icon-wrapper">
                  <Icon
                    className={classnames({ expanded })} name={expanded ? 'chevron-up' : 'chevron-down'}
                    width={8} height={8} />
                </div>
              </button>
            </ToolTip>
          </div>
        )}
      </nav>
    )
  }

  renderNavItem = (item) => {
    const isActiveNavPath = (path, additionalPaths = [], exclusionPaths = []) => {
      return [path, ...additionalPaths].some((pathItem) => {
        const isInPath = path => (
          window.location.pathname.startsWith(path) && pathItem.includes(path)
        )
  
        const hasExcludedPaths = exclusionPaths.length
        const isPartOfExclusionPath = hasExcludedPaths
          ? exclusionPaths.some(excludedPath => window.location.pathname.startsWith(excludedPath))
          : false
  
        return isInPath(pathItem) && !isPartOfExclusionPath
      })
    }
  
    return (
      <a
        href={`https://${item.domain || 'app'}.${DRIFT_APP_DOMAIN}${item.path}`}
        target={item.external ? '_blank' : '_self'}
        key={`${item.label}-${item.path}`}
        className={classnames('menu-item',
          'nav-item',
          { active: isActiveNavPath(item.path, item.additionalPaths, item.exclusionPaths) })}
      >
        <ToolTip className="navigation-hover-tooltip--wrapper" component={item.label}
          flow="right">
          <Icon name={item.iconSRC} className="menu-item-icon"
            height={item.height} width={item.width} />
        </ToolTip>
      </a>
    )
  }

  render() {
    const { orgId, orgProperties } = this.props

    if (this.hideNav()) {
      return null
    }

    if (this.state.isPendingCutover) {
      return (
        <div
          className={classnames("main-navigation", "new-main-nav", {
            darkMode: false,
            "main-navigation--qa": window.__ENV__ !== "PRODUCTION"
          })}
        />
      )
    }

    const hovered = this.state.scrollContainerHovered
    const setHovered = hovered => this.setState(({ scrollContainerHovered: hovered }))

    return (
      <div
        className={classnames("main-navigation", "new-main-nav", {
          darkMode: false,
          "main-navigation--qa": window.__ENV__ !== "PRODUCTION"
        })}
      >
        <A
          href={this.resolveHomePath()}
          className={classnames("main-navigation-home logo", {
            active: this.isHomePath()
          })}
        >
          <span is tooltip={"Home"} flow="right">
            <Icon
              name="lightning-bolt-filled"
              className="logo-hover-bolt large"
              height={16}
              width={12}
            />
            <Icon
              name="lightning-bolt-filled"
              className="logo-hover-bolt small1"
              height={15}
              width={11}
            />
            <Icon
              name="lightning-bolt-filled"
              className="logo-hover-bolt small2"
              height={16}
              width={12}
            />
            <HomeLogoIcon src={LOGO} className="tide-icon drift-logo" />
          </span>
        </A>
        <div className={classnames('navigation-scroll-container', {
          'navigation-scroll-container--hovered': hovered
        })}>
          <div
            className="navigation-scroll-container-content"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}>
            {this.renderNavItems()}
            <div className="navigation-scroll-container-spacer" />
            <div className="status-section">
              {ACCESS.isAdmin() && <Onboarding orgId={orgId} orgProperties={orgProperties} />}
              {ACCESS.isAdmin() && !ACCESS.hasPaidGates() && <UpgradeStatus />}
              <AppSwitcher showVideoOption={ACCESS.isAdmin() || !this.state.hasVideoIconCutover} />
              <Help />
              {ACCESS.isAdmin() && <Settings />}
            </div>
          </div>
        </div>
        <div className="agent-status-container">
          <NewAgentStatus hasDriftHelpCutover={this.state.hasDriftHelpCutover} />
        </div>
      </div>
    )
  }
}

export default MainNav



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/index.js